import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { WifiOff, Wifi } from 'lucide-react';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

const OfflineIndicator: React.FC = () => {
  const isOnline = useOnlineStatus();
  const [showOnlineMessage, setShowOnlineMessage] = React.useState(false);
  const [wasOffline, setWasOffline] = React.useState(false);

  React.useEffect(() => {
    // Only show "Back online" message when transitioning from offline to online
    if (isOnline && wasOffline) {
      setShowOnlineMessage(true);
      setWasOffline(false);
      const timer = setTimeout(() => {
        setShowOnlineMessage(false);
      }, 3000);
      return () => clearTimeout(timer);
    } else if (!isOnline) {
      setWasOffline(true);
    }
  }, [isOnline, wasOffline]);

  return (
    <AnimatePresence>
      {(!isOnline || showOnlineMessage) && (
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -100, opacity: 0 }}
          transition={{ type: 'spring', damping: 20 }}
          className={`fixed top-0 left-0 right-0 z-50 ${
            isOnline
              ? 'bg-green-500'
              : 'bg-yellow-500'
          } text-white px-4 py-3 shadow-lg`}
        >
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
            {isOnline ? (
              <>
                <Wifi size={20} />
                <span className="font-medium">Back online</span>
              </>
            ) : (
              <>
                <WifiOff size={20} />
                <span className="font-medium">You are offline</span>
              </>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default OfflineIndicator;
